<template>
	<div class="lostTypeWrap ">
		<span :class="getStatus()">{{ line[item.value] }}</span>
	</div>
</template>

<script>
export default {
	name: "LostType",
	props: {
		item: Object,
		line: Object
	},
	methods: {
		getStatus() {
			return this.line[this.item.value] === 'Off' ? 'text-red' : 'text-green';
		},
	}
};
</script>

<style scoped lang="scss">
 .lostTypeWrap {
	 width: 100%;
	 text-align: center;
	 .text-red {
		 color: rgba(228, 3, 42, 0.7);
	 }
	 .text-green {
		 color: #3ad558;
	 }
 }
</style>
